// extracted by mini-css-extract-plugin
module.exports = {"mid-term-neighbourhoods-container":"MidTermNeighbourhoods_mid-term-neighbourhoods-container__b4Eh8","filter-item-container":"MidTermNeighbourhoods_filter-item-container__t1nhc"};